import React from 'react';
import { Award, BookOpen, Briefcase, TrendingUp } from 'lucide-react';
import { AnimatedSection } from './AnimatedSection';
export function CertificationAuthority() {
  return <AnimatedSection className="py-24 bg-warm-white" data-id="element-22">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-24">
          <h2 className="text-3xl lg:text-4xl font-heading text-primary-900 mb-4" data-id="element-25">
            Industry-Recognized Training
          </h2>
          <p className="text-warm-gray-600 font-body text-lg" data-id="element-26">
            Built on proven frameworks and aligned with professional standards
            across the pet care industry.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-27">
          <div className="bg-white p-8 rounded-2xl shadow-warm border border-warm-gray-100" data-id="element-28">
            <div className="w-14 h-14 bg-primary-50 rounded-2xl flex items-center justify-center mb-6" data-id="element-29">
              <Award className="w-7 h-7 text-primary-800" data-id="element-30" />
            </div>
            <h3 className="font-heading text-xl text-primary-900 mb-3" data-id="element-31">
              Pet Tech Certified Training
            </h3>
            <p className="font-body text-warm-gray-600 text-sm leading-relaxed" data-id="element-32">
              Built on Pet Tech's proven CPR & First Aid training framework —
              the most widely recognized pet emergency education system.
            </p>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-warm border border-warm-gray-100" data-id="element-33">
            <div className="w-14 h-14 bg-primary-50 rounded-2xl flex items-center justify-center mb-6" data-id="element-34">
              <BookOpen className="w-7 h-7 text-primary-800" data-id="element-35" />
            </div>
            <h3 className="font-heading text-xl text-primary-900 mb-3" data-id="element-36">
              7 CEUs Available
            </h3>
            <p className="font-body text-warm-gray-600 text-sm leading-relaxed" data-id="element-37">
              Earn 7 Continuing Education Units through PACCC-recognized
              certification pathways, supporting your professional development.
            </p>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-warm border border-warm-gray-100" data-id="element-38">
            <div className="w-14 h-14 bg-primary-50 rounded-2xl flex items-center justify-center mb-6" data-id="element-39">
              <Briefcase className="w-7 h-7 text-primary-800" data-id="element-40" />
            </div>
            <h3 className="font-heading text-xl text-primary-900 mb-3" data-id="element-41">
              Industry-Recognized Skills
            </h3>
            <p className="font-body text-warm-gray-600 text-sm leading-relaxed" data-id="element-42">
              Training aligned with real-world pet care professionals across
              grooming, boarding, training, and rescue environments.
            </p>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-warm border border-warm-gray-100" data-id="element-43">
            <div className="w-14 h-14 bg-primary-50 rounded-2xl flex items-center justify-center mb-6" data-id="element-44">
              <TrendingUp className="w-7 h-7 text-primary-800" data-id="element-45" />
            </div>
            <h3 className="font-heading text-xl text-primary-900 mb-3" data-id="element-46">
              Professional Pathway
            </h3>
            <p className="font-body text-warm-gray-600 text-sm leading-relaxed" data-id="element-47">
              Structured learning from fundamentals to hands-on certification —
              designed for both pet owners and career professionals.
            </p>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}